<div class="container-fluid my-5">
    <div class="row">
        <div class="col-12">
            <img src="assets/img/internet.jpeg" class="rounded w-100" />
        </div>
    </div>
</div>
